import API from '@/shared/plugins/Api/API'

class MonitoringV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  async getDashboard () {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/monitoring`
    })
    return response?.data ?? response
  }

  async get (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/application/${encodeURIComponent(appName)}/monitoring`
    })
    return response
  }
}

export default MonitoringV3
